import api from '@/api/index'

// Add cooldown for click counts
const cooldownIds = []
const addCooldown = (id) => {
  cooldownIds.push(id)
  setTimeout(() => {
    const index = cooldownIds.indexOf(id)
    if (index > -1) {
      cooldownIds.splice(index, 1)
    }
  }, 1000)
}

const visitorApi = {
  async signup (payload) {
    const path = '/v2/visitor/signup'
    const response = await api.asyncRequest(path, 'post', payload)
    return response.data
  },
  async startViewSession (payload) {
    const path = '/v2/visitorhistory'
    const response = await api.asyncRequest(path, 'post', payload)
    return response.data
  },
  async updateViewSession (id) {
    const path = '/v2/visitorhistory/' + id
    const response = await api.asyncRequest(path, 'patch')
    return response.data
  },
  async addDetailVisitorHistory ({ headquarter, payload }) {
    const path = '/v2/helper/visitorHistory?headquarter=' + headquarter
    const response = await api.asyncRequest(path, 'post', payload)
    return response.data
  },
  async addClickCount (identifierId, identifier = 'marker') {
    if (cooldownIds.includes(identifierId)) {
      return
    }
    addCooldown(identifierId)
    const path = '/v2/clickcount'
    const response = await api.asyncRequest(path, 'post', {
      identifier, // user, marker
      identifierId
    })
    return response.data
  }
}

export default visitorApi
